import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import useTheme from '../../hooks/useTheme';
import { getStackScreenOptions } from '../config/screenOptions';
import { InventoryStackParamList } from '../types/navigation.types';
import { createLazyScreen } from '../utils/lazyScreen';
import { SCREEN_TITLES } from '../config/constants';

// Lazy load screens
const InventoryListScreen = createLazyScreen(() => import('../../screens/inventory/inventory-list-screen'));
const InventoryItemDetailScreen = createLazyScreen(() => import('../../screens/inventory/inventory-item-detail-screen'));
const InventoryItemFormScreen = createLazyScreen(() => import('../../screens/inventory/inventory-item-form-screen'));
const InventoryItemCaptureScreen = createLazyScreen(() => import('../../screens/inventory/inventory-item-capture-screen'));
const StockMovementsScreen = createLazyScreen(() => import('../../screens/inventory/stock-movements-screen'));
const StockTransferScreen = createLazyScreen(() => import('../../screens/inventory/stock-transfer-screen'));
const ReorderDashboardScreen = createLazyScreen(() => import('../../screens/inventory/reorder-dashboard-screen').then(m => ({ default: m.ReorderDashboardScreen })));
const LocationListScreen = createLazyScreen(() => import('../../screens/inventory/location-list-screen'));
const LocationFormScreen = createLazyScreen(() => import('../../screens/inventory/location-form-screen'));
const StockTakeScreen = createLazyScreen(() => import('../../screens/inventory/stock-take-screen'));
const StockAnalyticsScreen = createLazyScreen(() => import('../../screens/analytics/stock-analytics-screen'));
const StockTakeApprovalsScreen = createLazyScreen(() => import('../../screens/inventory/stock-take-approvals-screen'));

const Stack = createStackNavigator<InventoryStackParamList>();

export function InventoryStack() {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Stack.Navigator screenOptions={getStackScreenOptions(colors)}>
      <Stack.Screen
        name="InventoryList"
        component={InventoryListScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="InventoryItemDetail"
        component={InventoryItemDetailScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="InventoryItemForm"
        component={InventoryItemFormScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="InventoryItemCapture"
        component={InventoryItemCaptureScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="StockMovements"
        component={StockMovementsScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="StockTransfer"
        component={StockTransferScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ReorderDashboard"
        component={ReorderDashboardScreen}
        options={{ title: t(SCREEN_TITLES.REORDER_MANAGEMENT, 'Reorder Management') }}
      />
      <Stack.Screen
        name="LocationManagement"
        component={LocationListScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="LocationForm"
        component={LocationFormScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen 
        name="StockTake" 
        component={StockTakeScreen} 
        options={{ headerShown: false }} 
      />
      <Stack.Screen
        name="StockAnalytics"
        component={StockAnalyticsScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="StockTakeApprovals"
        component={StockTakeApprovalsScreen}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
}